import { View } from "@react-pdf/renderer";
import { spacing } from "components/Resume/ResumePDF/styles";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { TemplateTwoPDFSection } from "./common";
import type { ResumeProfile } from "lib/redux/types";

export const Summary = ({
  profile,
  themeColor,
  heading,
}: {
  profile: ResumeProfile;
  themeColor: string;
  heading: string;
}) => {
  const { summary } = profile;

  return (
    <TemplateTwoPDFSection themeColor={themeColor} heading={heading}>
      <View wrap={false}>{summary && <ResumePDFText>{summary}</ResumePDFText>}</View>
    </TemplateTwoPDFSection>
  );
};
